import { TOGGLE_EMAIL_CONFIRMATION_DIALOG } from '../actions/types'

const emailConfirmationDialog = (state = 'closed', action) => {
  switch (action.type) {
    case TOGGLE_EMAIL_CONFIRMATION_DIALOG:
      return action.payload
    default:
      return state
  }
}

export { emailConfirmationDialog }
